import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { centimetersToInches } from '../../../utils/conversion';
import s from './Table.scss';

const convertCellsToInches = (setup, tableHtml) => {
	if (setup.units === 'inches') {
		return tableHtml.replace(/<td>([\d.,\s]+)<\/td>/g, (matches, cms) => {
			const { wholeInches, numerator = 0, denominator = 4 } = centimetersToInches(cms.replace(',', '.'), 16);
			return `<td>
				<span>${wholeInches}</span>
				${numerator > 0 ? `<span>${`${numerator}/${denominator}`}</span>` : ''}
			</td>`;
		});
	}
	return tableHtml;
};

const Table = ({ content, setup, gender, isHotspot = false, isSizeGuide = false, measurementContainer = false }) => {
	const classes = [s.table];
	let tableHtml = content.rawText;

	if (/%(wo)?men%/.test(content.rawText.toLowerCase())) {
		// Women / Man specific
		const tableGender = content.rawText.toLowerCase().match(/%((wo)?men)%/)[1];

		if (gender && tableGender !== gender) return null;

		classes.push(s.table__sizeGuide);
		classes.push(s[`table__${tableGender}`]);
	}

	if (/%unisex%/.test(content.rawText.toLowerCase())) {
		classes.push(s.table__sizeGuide);
	}

	if (measurementContainer) {
		classes.push(s.table__measurementChart);

		tableHtml = tableHtml.replace(/<tr><td>(\(\w\))/g, '<tr><td><span>$1</span>');

		tableHtml = convertCellsToInches(setup, tableHtml);
	}

	if (isSizeGuide !== false && isHotspot) {
		const matchSizeRegexp = new RegExp(`<tr><td>${isSizeGuide}</td><td>([\\d.,\\s]+)</td></tr>`, 'i');
		const sizeConversion = content.rawText.match(matchSizeRegexp)?.[1];
		if (!sizeConversion) return <div className={s.matchingSize} />;
		if (setup.units === 'inches') {
			const { wholeInches = 1, numerator = 0, denominator = 4 } = centimetersToInches(sizeConversion.replace(',', '.'), 16);
			return (
				<div className={[s.matchingSize, s.matchingSize__inches].join(' ')}>
					<span>{ wholeInches }</span>
					{ numerator > 0 && <span>{ `${numerator}/${denominator}` }</span> }
					<span>&quot;</span>
				</div>
			);
		}
		return (
			<div className={s.matchingSize}>
				<span>{ sizeConversion } cm</span>
			</div>
		);
	}

	return <div className={classes.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(tableHtml) }} />;
};

export default hot(module)(Table);
